// eslint-disable-next-line no-restricted-imports
import { extendTailwindMerge } from "tailwind-merge";

// Define the ID for our custom class group
type HeaderLevelGroupId = "header-level";

const twMerge = extendTailwindMerge<HeaderLevelGroupId>({
  extend: {
    classGroups: {
      // Assign the class names to our custom group ID
      "header-level": [
        "header-h6",
        "header-h5",
        "header-h4",
        "header-h3",
        "header-h2",
        "header-h1",
      ],
    },
    // Define conflicts for the new group
    conflictingClassGroups: {
      // Our header-level utilities conflict with standard Tailwind's
      // font size, line height, and font weight utilities.
      "header-level": ["font-size", "leading", "font-weight"],
    },
  },
});

export default twMerge;
